import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TextFieldValidationRules } from '../helpers'
import { ref, watch } from 'vue'
interface Props {
  modelValue: string | number
  type: 'text' | 'number'
  width?: string | number
  clearAfterClose?: boolean
  opened?: boolean
  rules?: TextFieldValidationRules
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VFieldEditable',
  props: {
    modelValue: {},
    type: {},
    width: { default: 200 },
    clearAfterClose: { type: Boolean, default: false },
    opened: { type: Boolean, default: false },
    rules: { default: undefined }
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props;





const menu = ref(props.opened)
const valid = ref(false)
const field = ref()

const close = () => {
  menu.value = false
}

const update = () => {
  if (!valid.value) return

  if (field.value === props.modelValue) return close()

  emit('update', field.value)
  close()
}

watch(
  () => props.modelValue,
  val => {
    if (val === field.value) return
    field.value = val
  },
  { immediate: true },
)

watch(
  () => menu.value,
  val => {
    if (!val && props.clearAfterClose) field.value = props.modelValue
  },
)

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: menu.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menu).value = $event)),
    "close-on-content-click": false,
    width: props.width
  }, {
    activator: _withCtx(({ props }) => [
      _renderSlot(_ctx.$slots, "activator", { props: props })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        modelValue: valid.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((valid).value = $event)),
        onSubmit: _withModifiers(update, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            variant: "elevated",
            elevation: "5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "pb-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: field.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((field).value = $event)),
                    type: _ctx.type,
                    rules: _ctx.rules
                  }, null, 8, ["modelValue", "type", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "ml-2",
                    type: "submit",
                    variant: "text",
                    color: "primary",
                    size: "small",
                    density: "comfortable",
                    icon: "mdi-check"
                  }),
                  _createVNode(_component_v_btn, {
                    class: "ml-2",
                    variant: "text",
                    color: "primary",
                    size: "small",
                    density: "comfortable",
                    icon: "mdi-window-close",
                    onClick: close
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onSubmit"])
    ]),
    _: 3
  }, 8, ["modelValue", "width"]))
}
}

})